<template>
  <div class="result">
    <!-- <div class="bg"></div>
        <div class="bg2"></div> -->
    <AppNavbar
      v-if="!isShare"
      :placeholder="true"
      :options="options"
      :zIndex="999"
      title="体质评估报告"
      :backCallback="bindBack"
    >
      <div slot="right" v-if="resultData">
        <span
          class="share iconfont icon-share"
          @click="bindShare"
          v-clickBuried
          :data-click-buried="buriedData[info.user_type].clickShare"
        ></span>
      </div>
    </AppNavbar>
    <div class="download" v-if="isShare">
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
        alt=""
      />
      <div class="center">
        <div class="text1">一键获取同款体质评估报告</div>
        <div class="text2"
          >下载betterWE星球 APP,了解属于你的「超级减脂开关」</div
        >
      </div>
      <div class="btn">
        <span>打开APP</span>
        <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
      </div>
    </div>
    <div
      class="container"
      v-if="resultData"
      id="question-container"
      v-pageBuried
      :data-page-buried="buriedData[info.user_type].page"
    >
      <div class="user-info">
        <img class="avatar" :src="info.user_info.head_img" alt="" />
        <div class="nickname">{{ info.user_info.nickname || '' }}</div>
      </div>
      <div class="content-item content-item-1">
        <div class="item-top">
          <div class="top-title"
            >{{
              (isShare ? info.user_info.nickname : '您') | filterNickname
            }}的体质属于</div
          >
          <img
            class="top-logo"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a62fdd78125fd49b6cbae6e02cbcc5f8.png"
            alt=""
          />
        </div>
        <!--类型图片 -->
        <img class="type-image" :src="resultData.titleImage" alt="" />
        <div class="c-padding">
          <div class="super-food-title"
            >{{
              (isShare ? info.user_info.nickname : '您') | filterNickname
            }}的超级食物是
          </div>
          <!-- 超级食物图片 -->
          <img class="super-food-image" :src="resultData.foodImage" alt="" />
          <div class="coach-content">
            <img
              class="coach-info"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d5fa00da91bf2feccf926cbab6d1a5f9.png"
              alt=""
            />
            <div class="effect-title">营养师说</div>
            <div class="coach-text" v-html="resultData.coachSay.text"></div>
            <div class="effect-title">产生的影响</div>
            <div class="coach-text" v-html="resultData.coachSay.effect"></div>
            <div class="effect-tip">
              该报告仅为简单的初步自测结果，每个人皆因生活习惯、饮食方式、环境、遗传等原因，具有特殊性，若与大众结果出现偏差或欲进一步进行权威分析，<span
                class="bold"
                @click="bindGetPlan"
                v-clickBuried
                :data-click-buried="buriedData[info.user_type].clickPlan1"
                >请咨询专业营养师>></span
              ></div
            >
          </div>
        </div>
      </div>
      <div class="content-item content-item-2" id="content-item-2">
        <div class="item-top">
          <img
            class="item-top-title"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8ce8d24228e4b8b5152a77aac187c732.png"
            alt=""
          />
          <div class="item-top-num">{{ resultData.firstList.length }}项</div>
        </div>
        <div class="question">
          <div
            class="q-item"
            v-for="(item, index) in resultData.firstList"
            :key="index"
          >
            <div class="q-item-title"
              ><span class="q-title-index">{{ (index + 1) | filterIndex }}</span
              >{{ item.title }}</div
            >
            <div class="q-item-btm">
              <div class="q-item-text">{{ item.text }}</div>
              <img class="q-item-icon" :src="item.icon" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="content-item content-item-3">
        <div class="my-method-1-title">定制减脂方案已为您生成..</div>
        <div class="my-method-1" v-if="info.user_info.age >= 21">
          <div class="my-method-1-position">
            <div class="flag">为{{ info.user_info.nickname }}针对性定制</div>
          </div>
          <div class="padding-18">
            <img
              class="plan-title"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/847d28b51b425351e06b4de7e37f56ef.png"
              alt=""
            />
          </div>
          <div class="plan-image-container">
            <img
              class="plan-image"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8c4ac2b5af3864dd01c9e502cf025f9d.png"
              alt=""
            />
            <img class="less-weight-image" :src="lessImageIcon" alt="" />
          </div>
          <div class="plan-image-content">
            <img
              class="plan-image"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/563c19959d31e1dbb6a205542bd1eabe.png"
              alt=""
            />
            <div
              class="get-plan-btn"
              @click="bindGetPlan"
              v-buried
              :data-buried="buriedData[info.user_type].bgPlan1"
              v-clickBuried
              :data-click-buried="buriedData[info.user_type].clickPlan1"
            >
              <img
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/66c0dd971e8adf41bc496d311453f42c.png"
                alt=""
              />
              <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
            </div>
            <div class="tips"
              >*为确保方案的针对性，<br />在开始指导前需添加助教进行专业身体代谢分析</div
            >
          </div>
        </div>
        <div
          class="my-method-2"
          :class="{ 'my-method-2-padding': info.user_info.age >= 21 }"
        >
          <!--  <div class="plan2-text">没准备好，想先试试？</div> -->
          <div class="card-content" :class="{ 'card-limit': !showMore }">
            <div class="plan2-card-content">
              <img
                class="image-method"
                src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/b4abcad200c0066bb99cb0dd464a4cee_wh=1029_954.png"
                alt=""
              />
              <div class="time-out-container">
                <span class="time-text">优惠倒计时</span>
                <van-count-down
                  :time="time"
                  millisecond
                  @finish="bindTimeFinish"
                  ref="countdown"
                >
                  <template #default="timeData">
                    <span class="block">{{ timeData.hours | filterNum }}</span>
                    <span class="colon">:</span>
                    <span class="block">{{
                      timeData.minutes | filterNum
                    }}</span>
                    <span class="colon">:</span>
                    <span class="block">{{
                      timeData.seconds | filterNum
                    }}</span>
                    <span class="colon">:</span>
                    <span class="block">{{
                      timeData.milliseconds | filterMilliseconds
                    }}</span>
                  </template>
                </van-count-down>
              </div>
              <div class="plan2-card-btn" @click="bindBuy"></div>
            </div>
            <!-- <div class="card-image-container">
              <img
                v-if="info.user_info.age >= 21"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2855a6e9492205a8d6f27fcf9dd9e22b.png"
                alt=""
              />
              <img
                v-else
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1516e6f6871bb09305cc1670f2cc5c04.png"
                alt=""
              />
            </div>
            <img
              class="card-banner" @click="bindJumpMemberSign"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e03dfeb56b8cbcc22383cabe139e8b73.png"
              alt=""
            />
            <div class="receive-btn" @click="bindJumpMemberSign"
              ><span>限时0元领取</span
              ><span class="receive-origin-price">原价¥199</span><span class="receive-btn-flag">限前150名</span>
              </div> -->
            <!-- 权益列表 -->
            <div class="right-list">
              <img
                class="image-item"
                src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/f5d960571e15c267b0f6aca4b759a260_wh=1029_3396.png"
                alt=""
              />
            </div>
            <div class="mask" v-show="!showMore"></div>
          </div>
          <div class="toggle-status" @click="bindToggleOpen">{{
            showMore ? '收起' : '查看更多'
          }}</div>
          <div
            class="consult-btn"
            v-if="!info.user_info.is_weplus"
            @click="bindBuy"
            v-buried
            :data-buried="buriedData[info.user_type].bgPlan2"
            v-clickBuried
            :data-click-buried="buriedData[info.user_type].clickPlan2"
            >立刻了解<span class="iconfont icon-you"></span>
            <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
          </div>
          <img
            class="right-image-title"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/884195bea24801c8a6a1deed85f58fb7.png"
            alt=""
          />
          <div class="case-container">
            <div class="case-list">
              <img
                class="case-item"
                :src="item.image"
                v-for="(item, index) in caseList"
                :key="index"
                alt=""
                @click="bindClickCase(item)"
              />
            </div>
          </div>
        </div>
        <div class="join-group" v-if="showGroup">
          <img
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b31bcaac9a14fc595749ef36e8815de9.png"
            alt=""
          />
          <div class="join-group-btn" @click="bindJoinGroup"></div>
        </div>
      </div>
      <div class="content-item content-item-4" id="content-item-4">
        <img
          class="top-title"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c96fd3f9f1a4a999b797726343f933b6.png"
          alt=""
        />
        <div class="i-title">控制摄入</div>
        <div class="i-desc"
          ><span class="danger iconfont icon-warning-fill"></span
          >{{ resultData.recommendation.controlFood.desc }}
        </div>
        <div class="food-list" id="food-list">
          <van-popover
            class="food-pop-item"
            :placement="offsetObj[index % 4]"
            :get-container="'#food-item' + index"
            v-model="item.showPopover"
            trigger="click"
            v-for="(item, index) in resultData.recommendation.controlFood.list"
            :key="index"
          >
            <div class="tips-text">{{ item.tips }}</div>
            <template #reference>
              <div class="food-item" :id="'food-item-' + index">
                <div class="item-image">
                  <div class="wenhao"><span class="iconfont">?</span></div>
                  <img class="food-image" :src="item.icon" alt="" />
                </div>
                <div class="item-name">{{ item.name }}</div>
              </div>
            </template>
          </van-popover>
        </div>
        <div class="i-title">推荐摄入</div>
        <div class="i-desc"
          ><span class="zan iconfont icon-a-dianliang3x"></span
          >{{ resultData.recommendation.recommendFood.desc }}
        </div>
        <div class="recommend-food">
          <img
            class="recommend-item"
            v-for="(item, index) in resultData.recommendation.recommendFood
              .list"
            :key="index"
            :src="item.icon"
          />
        </div>
        <div class="consult-us" v-if="info.user_info.age >= 21">
          <div class="consult-top">
            <img
              class="consult-avatar"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d4411627b5ebeedbabec42b5dc56ee64.png"
              alt=""
            />
            <div class="consult-nickname"
              >{{
                (isShare ? info.user_info.nickname : '你') | filterNickname
              }}的营养师顾问
            </div>
            <div class="consult-btn" @click="bindGetPlan">
              <div v-if="isShare">下载APP</div>
              <div v-else class="consult-icon"
                >咨询TA<span class="iconfont icon-you"></span
              ></div>
              <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
            </div>
          </div>
          <div class="consult-text">
            根据您的评估结果，控制摄入和推荐摄入的食物具有一定的普适性，但每个人体质都是不同的。想要获取更多控制摄入和推荐摄入的饮食建议或更针对性的专业饮食方案指导，可以咨询我哦！</div
          >
        </div>
      </div>
      <img
        class="gray-logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a62fdd78125fd49b6cbae6e02cbcc5f8.png"
        alt=""
      />
      <div
        class="fixed-btn"
        :class="[fixedBtnOpacity ? 'fixed-btn-opacity-1' : '']"
        v-show="fixedBtn"
        v-if="
          (!info.user_info.is_weplus &&
            info.card_list &&
            info.card_list.length) ||
          isShare
        "
      >
        <div class="btn launch-btn" @click="bindSelectPlan"
          >{{ isShare ? '下载betterWE星球 APP' : '选择方案' }}
          <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
        </div>
      </div>
      <SelectPlan
        v-model="showSelectPlan"
        :data="resultData"
        :cardList="info.card_list"
        :lessData="lessData"
        @confirm="bindConfirmPlan"
      />
      <!-- 分享组件 -->
      <ShareComponent
        v-model="showShare"
        :options="iconList"
        @cancel="bindCancel"
        @select="bindSelect"
        :qrcodeUrl="qrcodeUrl"
      />
      <QuestionLoading v-if="showSubmitLoading" @end="bindLoadingEnd" />
    </div>
  </div>
</template>
<script>
import QuestionLoading from './components/loading.vue'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import { eventObj } from '@/components/app/share/share-method.js'
import SelectPlan from './components/select-plan.vue'
import ShareComponent from '@/components/app/share/share.vue'
import { ResultData, BuriedData } from './result-data.js'
export default {
  name: 'newcomer-questionnaire-v2-result',
  components: {
    AppNavbar,
    SelectPlan,
    ShareComponent,
    WxOpenLaunchApp,
    QuestionLoading
  },
  filters: {
    filterIndex(index) {
      return index > 9 ? index : '0' + index
    },
    filterNickname(str) {
      if (str.length <= 4) {
        return str
      } else {
        return str.slice(0, 2) + '...' + str.slice(-2)
      }
    },
    filterNum(num) {
      return num > 9 ? num : '0' + num
    },
    filterMilliseconds(num) {
      return Math.floor(num / 100)
    }
  },
  computed: {
    yearCard() {
      if (this.info && this.info.card_list && this.info.card_list.length) {
        let res = this.info.card_list.find((item) => {
          return item.type_id == 3 && item.card_type_second_level == 1
        })
        if (!res) {
          return {}
        }
        let dailyPrice = (res.real_price / res.effective_time).toFixed(1)
        return {
          real_price: parseFloat(res.real_price),
          price: parseFloat(res.price),
          dailyPrice: dailyPrice
        }
      } else {
        return null
      }
    },
    lessImageIcon() {
      if (this.info) {
        return this.info.user_info.bmi < 24
          ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3a7d4d680d10e6d10c50e4a2c34962b9.png'
          : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/728f9599cd04e558d459c1e0ec62381b.png'
      }
      return ''
    },
    showGroup() {
      return this.info.user_info.age >= 18 && this.info.user_info.age < 21
    }
  },
  watch: {
    fixedBtn() {
      setTimeout(() => {
        this.fixedBtnOpacity = this.fixedBtn
      }, 200)
    }
  },
  data() {
    return {
      showSubmitLoading: false,
      buriedData: BuriedData,
      isShare: false,
      info: null,
      options: {
        barBackgroundColor: 'transparent',
        color: 'rgba(0,0,0,0.8)'
      },
      showShare: false,
      qrcodeUrl: '',
      extinfo: '',
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接',
          id: 3,
          copy: true,
          className: 'share-copy-btn'
        }
      ],
      resultData: null,
      offsetObj: ['top-start', 'top', 'top', 'top-end'],
      showPopover: false,
      curNav: 0,
      showMore: false,
      lessData: null,
      showSelectPlan: false,
      fixedBtn: false,
      fixedBtnOpacity: false,
      shareOptions: {
        //分享参数
        url: '',
        desc: '我的体质评估报告',
        title: '93.6%的易胖困扰，都来自长期体质问题哦！',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-share-image'
      },
      caseList: [
        {
          name: '雪娥',
          id: 345,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bcb6d8153e7c58d66f7f0d8b0430f5cf.png'
        },
        {
          name: '栗子',
          id: 1353,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4e911af0256bec7b86d9d06f819d03ec.png'
        },
        {
          name: '艾拉',
          id: 756,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/19a5c8dc8215f7170a60bd0660018a21.png'
        },
        {
          name: 'sliviaW',
          id: 1603,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c0fb832b255d104817c5f72e4397b88e.png'
        },
        {
          name: 'seven',
          id: 1692,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d3120f8c67c575c56343439d65ed8eb1.png'
        },
        {
          name: '刘拼',
          id: 1423,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/242b1967252bb473344874fb5e473f23.png'
        }
      ],
      showGif: false,
      time: 0
    }
  },
  created() {
    if (this.$route.query.loading) {
      this.showSubmitLoading = true
    }
    this.isShare = !this.$http._isApp()
    this.qrcodeUrl = location.href
    this.extinfo =
      '/web?url=' +
      encodeURIComponent(
        location.origin + location.pathname + '?id=' + this.$route.query.id
      )
    this.getResultData()
  },
  mounted() {
    this.addScrollEvent()
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    bindLoadingEnd() {
      this.showSubmitLoading = false
    },
    bindCancel() {
      this.showShare = false
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    async bindBack() {
      if (this.$route.query.loading) {
        let version = await this.$betterwe.getAppVersion().catch(() => {
          this.$http.appBack()
        })
        if (version >= 220) {
          this.$betterwe.jumpRoute('/home?pageTag=1')
        }
      } else {
        this.$http.appBack()
      }
    },
    bindShare() {
      this.showShare = true
    },
    bindToggleOpen() {
      this.showMore = !this.showMore
    },
    bindJumpLowCodePage() {
      this.$betterwe.jumpRoute(
        '/web?url=' +
          encodeURIComponent(
            'https://btvue.gymcity.com.cn/lowcode-active?pageid=290'
          )
      )
    },
    /* 跳转大会员页 */
    bindBuy() {
      if (this.isShare) {
        return
      }
      let url = '/vipHomePage'
      if (this.info && this.info.card_list && this.info.card_list.length) {
        let card = this.info.card_list.find((item) => {
          return item.type_id == 3 && item.card_type_second_level == 1
        })
        if (card) {
          url =
            url +
            '?card_type_attr=' +
            card.card_type_second_level +
            '&vip_type_id=' +
            card.type_id
        }
      }
      this.$betterwe.onAppPageUrlRoute(url)
    },
    bindClickNav(index) {
      this.curNav = index
    },
    /* 获取完整个性方案 */
    bindGetPlan() {
      if (this.isShare) {
        return
      }
      this.$betterwe.jumpRoute(this.resultData.plan1.consultUrl)
    },
    bindSelectPlan() {
      if (this.isShare) {
        return
      }
      this.showSelectPlan = true
    },
    bindClickCase(item) {
      this.$router.push({
        path: '/case-detail',
        query: {
          id: item.id
        }
      })
    },
    getResultData() {
      this.$http
        .getBaseApp('member/AppCamp/getNewComerQueV2', {
          rid: +this.$route.query.id
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.card_list = res.data.card_list || []
            this.info = res.data
            this.resultData = ResultData.find((item) => {
              return item.enTitle == this.info.user_type
            })
            if (this.$route.query.loading) {
              this.$betterwe.addCompleteTest()
            }
            this.lessData = this.getLessData(
              this.info.user_info.bmi,
              this.resultData.fat
            )
            this.init()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    bindConfirmPlan(index) {
      if (this.isShare) {
        return
      }
      switch (index) {
        case 0:
          this.$betterwe.jumpRoute(this.resultData.selectPlanUrl)
          break
        case 1:
          this.bindBuy()
          break
      }
    },
    getLessData(bmi, fat) {
      let arr = [
        {
          less: '8-10斤',
          time: '21天',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a70b29b93ff4c1ea33ed7f12143a6b0f.png',
          gif: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/42cf7f2910c881596754e682c427b1fc.png',
          methodsImage:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9f4e9d4eb2fce1fa4141534556db249b.png'
        },
        {
          less: '10-25斤',
          time: '84天',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a70b29b93ff4c1ea33ed7f12143a6b0f.png',
          gif: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/26af23b5e5bbd51041d2529c40dab9c2.png',
          methodsImage:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/61b8183318d08b3df4c89a1b36e63aa5.png'
        }
      ]
      let iconData = {
        全身: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/103726ce3c96f164f0f053bd4aeb3fcc.png',
        腰腹: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/103726ce3c96f164f0f053bd4aeb3fcc.png',
        臀腿: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ac61e13f8fdac21817c0358891a5b195.png'
      }
      let index = 0
      if (bmi < 24) {
        index = 0
      } else {
        index = 1
      }
      let res = arr[index]
      res.body = fat
      res.icon = iconData[fat]
      return res
    },
    /* getLessData(bmi,fat) {
        let arr = [
            {
                less: "5-8",
                time:"21天",
                image: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7e0aba25fe0acf06d09cf75c4253e4b0.png",
                gif: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/000a3350f7a987715dd19ec6ad9729fa.gif",
            },
            {
                less: "8-15",
                time:"21天",
                image: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5add9078f166bc20e678ec7841b3950c.png",
                gif: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cebaa3276627c56ad59f7343f547ea76.gif",
            },
            {
                less: "15-25",
                time:"84天",
                image: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a25eb19c61c631d5978aaa2dd5d19bdc.png",
                gif: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/eb63b178d0b9064d89a2d0f43d39057d.gif",
            },
            {
                less: "25+",
                time:"84天",
                image: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8570daf0afda07122d8e94e8595b1d30.png",
                gif: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cebaa3276627c56ad59f7343f547ea76.gif",
            },
        ];
        let index = 0;
        if (bmi < 20) {
            index = 0;
        } else if (bmi >= 20 && bmi < 22) {
            index = 1;
        } else if (bmi >= 22 && bmi < 24) {
            index = 2;
        } else {
            index = 3;
        }
        let res = arr[index];
        res.body = fat;
        return res;
    }, */
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    updateFixedBtn(scrollTop) {
      let el = document.getElementById('content-item-4')
      let content = document.getElementById('question-container')
      if (el && content) {
        if (scrollTop + content.offsetTop >= el.offsetTop) {
          this.fixedBtn = true
        } else {
          this.fixedBtn = false
        }
      }
    },
    updateGif(scrollTop) {
      if (this.showGif) {
        return
      }
      let el = document.getElementById('tab-content')
      if (
        el &&
        scrollTop + window.screen.height > el.offsetTop + el.offsetHeight / 2
      ) {
        this.showGif = true
      }
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset ||
        0
      this.updateFixedBtn(scrollTop)
      //this.updateGif(scrollTop);
      if (scrollTop >= 100) {
        this.options = {
          barBackgroundColor: '#fff',
          color: 'rgba(0,0,0.8)'
        }
      } else {
        let p = parseFloat((scrollTop / 100).toFixed(2))
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, ' + p + ')',
          color: 'rgba(0,0,0,0.8)'
        }
      }
    },
    bindJoinGroup() {
      this.$betterwe.jumpRoute(
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252Fb5675bc0d2fdad0b768089fa1d854f8b.png'
      )
    },
    bindJumpMemberSign() {
      this.$betterwe.jumpRoute(
        '/web?url=https%3A%2F%2Fbtvue.gymcity.com.cn%2Factivity%2Fmember-sign-in'
      )
    },
    //倒计时结束
    bindTimeFinish() {
      console.log('倒计时结束')
      //重复30分钟
      this.time = this.getTimeOut()
      this.$refs.countdown.reset()
    },
    init() {
      this.time = this.getTimeOut()
    },
    getTimeOut() {
      let firstTime = localStorage.getItem('vip-timeout-flag')
      if (!firstTime) {
        localStorage.setItem(
          'vip-timeout-flag',
          new Date().toLocaleString().replace(/-/g, '/')
        )
        return 30 * 1000 * 60
      }
      let now = new Date()
      let nowTimes = now.getTime()
      let firstTimeNum = new Date(firstTime).getTime()
      let halfHours = 1000 * 60 * 30
      let repeatTime = halfHours - ((nowTimes - firstTimeNum) % halfHours)
      return repeatTime
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  position: relative;
  z-index: 1;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a9747e75ded580ae2c9e9b556c2da825.png');
  background-size: 100%;
  background-position: center top;
  background-repeat: no-repeat;
  background-color: #fbfeb2;
  min-height: 100vh;

  ::v-deep .van-popover__arrow {
    color: rgba(0, 0, 0, 0.38);
  }

  ::v-deep .van-popover__content {
    background: rgba(0, 0, 0, 0.38);
    backdrop-filter: blur(16px);
  }

  .bg {
    background: linear-gradient(218deg, #81ef5f 0%, #c2fd84 100%);
    position: absolute;
    width: 100%;
    height: 401px;
    left: 0;
    top: 0;
    z-index: -1;
  }

  .bg2 {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      #f9f9f9 100%
    );
    position: absolute;
    width: 100%;
    height: 401px;
    left: 0;
    top: 0;
    z-index: -1;
  }

  .container {
    padding: 30px 16px 30px;

    .user-info {
      padding-left: 20px;
      display: flex;
      align-items: center;
      margin-bottom: 13px;

      .avatar {
        width: 22px;
        height: 22px;
        object-fit: cover;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 8px;
      }

      .nickname {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
      }
    }

    .content-item {
      background: #ffffff;
      box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      margin-bottom: 24px;
    }

    .content-item-1 {
      padding: 22px 0px 24px;

      .item-top {
        padding: 0px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 9px;

        .top-title {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #0d0d0d;
          line-height: 20px;
        }

        .top-logo {
          width: 58px;
          height: 10px;
        }
      }

      .c-padding {
        padding: 0px 20px;
      }

      .type-image {
        width: 100%;
        min-height: 373px;
        object-fit: contain;
        margin-bottom: 29px;
      }

      .super-food-title {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(13, 13, 13, 0.8);
        line-height: 20px;
        margin-bottom: 10px;
      }

      .super-food-image {
        width: 100%;
        margin-bottom: 30px;
      }

      .coach-content {
        .coach-info {
          width: 309px;
        }

        .coach-text {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(13, 13, 13, 0.5);
          line-height: 18px;
          margin-bottom: 6px;
        }

        .effect-tip {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(13, 13, 13, 0.5);
          line-height: 18px;
          margin-top: 20px;

          .bold {
            font-weight: bold;
            color: rgba(27, 150, 255, 1);
          }
        }

        .effect-title {
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #0d0d0d;
          line-height: 20px;
          margin-bottom: 4px;
        }
      }
    }

    .content-item-2 {
      padding: 26px 20px 24px;

      .item-top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item-top-title {
          width: 130px;
          height: 22px;
        }

        .item-top-num {
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(104, 227, 66, 1);
          line-height: 17px;
        }
      }

      .question {
        .q-item {
          padding: 22px 0px 15px;
          border-bottom: 1px dashed rgba(13, 13, 13, 0.09);

          .q-item-title {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #0d0d0d;
            line-height: 22px;
            margin-bottom: 3px;

            .q-title-index {
              font-size: 18px;
              font-family: DINPro-Black, DINPro;
              font-weight: 900;
              color: #0d0d0d;
              line-height: 18px;
              margin-right: 8px;
            }
          }

          .q-item-btm {
            display: flex;
            align-items: flex-start;

            .q-item-text {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(13, 13, 13, 0.5);
              line-height: 18px;
              margin-right: 20px;
            }

            .q-item-icon {
              width: 50px;
              height: 50px;
            }
          }
        }

        .q-item:last-child {
          padding: 22px 0px 0px;
          border-bottom: none;
        }
      }
    }

    .content-item-3 {
      background-color: transparent;
      box-shadow: none;
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ed1ea97b6d8df7959f355dc4098d7ae5.png');
      background-size: 100%;
      background-position: center top;
      background-repeat: no-repeat;

      .my-method-1-title {
        text-indent: 26px;
        height: 56px;
        line-height: 56px;
        font-weight: bold;
        font-size: 22px;
        color: #ffffff;
      }

      .my-method-1 {
        background: #fff5de;
        box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.03);
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid #fee4a7;
        margin-bottom: 20px;
        .my-method-1-position {
          position: relative;
        }

        .flag {
          border-top: 3px solid transparent;
          border-left: 18px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 11px solid transparent;
          border-image-source: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a910c284244e06eb66ff88c3e455e6bd.png');
          border-image-slice: 0% 6.9% 0% 15.66% fill;
          border-image-width: 0% 6.9% 0% 15.66%;
          position: absolute;
          right: 0;
          top: -1px;
          font-size: 10px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #a16315;
          line-height: 16px;
        }

        .plan-title {
          width: 54px;
          height: 17px;
          margin-bottom: 5px;
        }

        .padding-18 {
          padding: 43px 18px 0px;
        }

        .plan-text {
          font-size: 22px;
          font-family: MiSans-Semibold, MiSans;
          font-weight: 600;
          color: #a16315;
          line-height: 32px;
          border-bottom: 2px solid #a16315;
          margin-bottom: 9px;
        }

        .plan-banner {
          width: 252px;
          height: 21px;
          margin-bottom: 30px;
        }
        .plan-image-container {
          position: relative;
          .less-weight-image {
            position: absolute;
            width: 92px;
            height: 80px;
            right: 15px;
            top: 75px;
          }
        }
        .plan-image {
          width: 100%;
        }
        .plan-image-content {
          position: relative;
          padding-bottom: 66px;
        }
        .plan-image-content::after {
          content: '';
          width: 100%;
          height: 399px;
          position: absolute;
          left: 0;
          bottom: 0;
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 1)
          );
        }
        .nav-list {
          background: #ffffff;
          border-radius: 12px;
          display: flex;
          align-items: center;
          margin-bottom: 18px;

          .nav-item {
            position: relative;
            z-index: 1;
            width: 153px;
            padding: 9px 0px;
            text-align: center;
            color: rgba(161, 99, 21, 0.8);
            font-size: 16px;
            .nav-item-title {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              line-height: 16px;
              margin-bottom: 2px;
            }

            .nav-item-btm {
              font-size: 14px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              line-height: 18px;
            }

            .nav-item-num {
              font-size: 17px;
              font-family: DINPro-Bold, DINPro;
              font-weight: bold;
              line-height: 18px;
            }
          }

          .nav-item-active {
            position: relative;
            transform: scaleY(1.1);
            font-weight: bold;
            font-size: 16px;
            color: #fff;
            line-height: 16px;
            background: linear-gradient(44deg, #ff6d42 0%, #ffa645 100%);
            box-shadow: 0px 3px 8px 0px rgba(161, 99, 21, 0.09);
            border-radius: 20px;

            .nav-item-title {
              transform: translateY(0.91);
            }
          }

          .nav-item-active::after {
            content: '';
            position: absolute;
            transform: translate(-6px, 0px);
            left: 50%;
            bottom: -6px;
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 7px solid rgb(255, 135, 67);
          }
        }

        .tab-content {
          margin-bottom: 16px;
          padding: 0px 8px;
          .tab-item {
            position: relative;
            margin: 0 auto;

            .tab-gif {
              position: absolute;
              width: 283px;
              left: 50%;
              top: 118px;
              transform: translate(-50%, -50%);
            }
          }
        }

        .tab-item-image {
          width: 100%;
          // height: 408px;
        }
        .tab-item-tips {
          padding: 0px 6px;
          font-size: 8px;
          color: rgba(161, 99, 21, 0.8);
          line-height: 14px;
        }
        .tips {
          position: absolute;
          z-index: 2;
          text-align: center;
          width: 100%;
          left: 0;
          bottom: 20px;
          font-size: 9px;
          color: rgba(161, 99, 21, 0.8);
          line-height: 16px;
        }
        .get-plan-btn {
          position: absolute;
          bottom: 66px;
          left: 50%;
          transform: translate(-50%, 0%);
          z-index: 1;
          width: 270px;
          height: 46px;
          box-shadow: 0px 5px 9px 0px rgba(251, 139, 76, 0.26);
          border-radius: 23px;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #fff;
          line-height: 46px;
          text-align: center;
          animation: btnScale 1.8s ease-in-out infinite;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .iconfont {
            margin-left: 4px;
          }
        }
        .coach-consult-image {
          width: 279px;
          margin: 12px auto 0px;
        }
      }

      .my-method-2 {
        padding: 10px 0px 23px;
        position: relative;
        background: #ffffff;
        box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.03);
        border-radius: 16px;
        border: 1px solid rgba(254, 228, 167, 1);

        .card-content {
          position: relative;
          .plan2-card-content {
            position: relative;
            .image-method {
              width: 100%;
            }
            .time-out-container {
              position: absolute;
              width: 100%;
              bottom: 96px;
              left: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              font-size: 12px;
              color: #5e3814;
              line-height: 20px;
              .time-text {
                margin-right: 7px;
              }
              .van-count-down {
                display: flex;
                align-items: center;
              }
              .colon {
                display: inline-block;
                margin: 0 4px;
                font-weight: bold;
                font-size: 14px;
                color: #4a3d6b;
              }
              .block {
                width: 20px;
                height: 20px;
                background: #5e3814;
                border-radius: 4px;
                display: inline-block;
                white-space: nowrap;
                overflow: hidden;
                color: #fff;
                text-align: center;
                font-weight: bold;
                font-size: 12px;
                color: #ffffff;
              }
            }
            .plan2-card-btn {
              position: absolute;
              left: 50%;
              bottom: 36px;
              transform: translate(-50%, 0%);
              width: 263px;
              height: 46px;
            }
          }
          .receive-btn {
            position: relative;
            margin: 19px auto 0px;
            width: 305px;
            height: 46px;
            background: linear-gradient(90deg, #ff6d42 0%, #ffa645 100%);
            border-radius: 23px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            color: #ffffff;
            .iconfont {
              margin-left: 4px;
            }
            .receive-origin-price {
              margin-left: 7px;
              font-size: 12px;
              color: rgba(255, 255, 255, 0.8);
              text-decoration-line: line-through;
            }
            .receive-btn-flag {
              height: 18px;
              position: absolute;
              top: 0;
              transform: translate(0%, -50%);
              right: 0;
              background: #7ae858;
              border-radius: 10px 10px 10px 1px;
              font-weight: bold;
              padding: 0px 6px;
              font-size: 12px;
              color: #ffffff;
              line-height: 18px;
            }
          }
          .card-image-container {
            margin-bottom: 4px;
            img {
              width: 100%;
            }
          }

          .mask {
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 0;
            height: 51px;
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0) 0%,
              #ffffff 100%
            );
          }
        }

        .card-limit {
          height: 790px;
          overflow: hidden;
        }
        .plan2-text {
          padding: 0px 14px;
          font-size: 14px;
          line-height: 14px;
          color: rgba(48, 48, 56, 0.6);
        }
        .subsidy-activity-container {
          padding: 0px 15px;
        }
        .subsidy-activity-tips {
          position: relative;
          z-index: 1;
          padding: 0px 6px;
          display: inline-block;
          font-family: MiSans, MiSans;
          font-weight: bold;
          font-size: 9px;
          color: #ffffff;
          line-height: 12px;
          height: 12px;
          border-radius: 6px;
          background: rgba(219, 194, 164, 1);
          margin-bottom: 4px;
        }
        .subsidy-activity-tips::after {
          position: absolute;
          z-index: -1;
          left: 16px;
          bottom: -3px;
          content: '';
          width: 0;
          height: 0;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
          border-left: 6px solid rgba(219, 194, 164, 1);
        }
        .subsidy-activity {
          font-size: 14px;
          color: rgba(161, 99, 21, 0.7);
          line-height: 20px;
        }
        .flag {
          border-top: 3px solid transparent;
          border-left: 18px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 11px solid transparent;
          border-image-source: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a910c284244e06eb66ff88c3e455e6bd.png');
          border-image-slice: 0% 6.9% 0% 15.66% fill;
          border-image-width: 0% 6.9% 0% 15.66%;
          font-size: 10px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #a16315;
          line-height: 16px;
          padding: 0px 8px;
          position: absolute;
          right: 0;
          top: -1px;
        }

        .right-list {
          margin-top: 24px;
          .image-item {
            width: 100%;
            margin-bottom: 14px;
          }
        }

        .card-banner {
          margin: 0 auto;
          width: 315px;
          height: auto;
        }

        .list {
          padding: 0px 30px;
          margin-bottom: 26px;

          .list-title {
            padding: 0 16px;
            background: linear-gradient(
              270deg,
              rgba(255, 242, 221, 0.5) 0%,
              rgba(249, 206, 122, 0.3) 100%
            );
            border-radius: 12px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(161, 99, 21, 0.79);
            line-height: 20px;
            margin-bottom: 12px;
          }

          .item {
            display: flex;
            align-items: flex-start;
            margin-bottom: 12px;

            .item-left {
              margin-top: 4px;
              width: 12px;
              height: 12px;
              background: #81ef5f;
              border-radius: 50%;
              margin-right: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-size: 10px;
            }

            .item-center {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;

              .item-center-top {
                display: flex;
                align-items: center;

                .item-center-top-text {
                  margin-right: 10px;
                  font-size: 12px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: rgba(161, 99, 21, 0.8);
                  line-height: 20px;
                }

                .item-center-top-line {
                  flex: 1;
                  flex-shrink: 0;
                  margin-right: 10px;
                  overflow: hidden;
                  height: 0;
                  border-bottom: 1px dashed rgba(161, 99, 21, 0.22);
                }

                .item-center-top-right {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: rgba(161, 99, 21, 0.79);
                  line-height: 20px;
                }

                .item-right-through {
                  text-decoration: line-through;
                }
              }

              .item-center-bottom {
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(161, 99, 21, 0.6);
                line-height: 13px;
              }

              .item-center-bottom-color {
                display: inline;
                background: #fffdc0;
              }
            }
          }

          .item:last-child {
            margin-bottom: 0px;
          }
        }

        .toggle-status {
          margin: 0 auto;
          width: 60px;
          text-align: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(13, 13, 13, 0.4);
          line-height: 17px;
          text-decoration: underline;
          margin-bottom: 20px;
        }

        .consult-btn {
          position: relative;
          z-index: 1;
          text-align: center;
          margin: 0 auto;
          width: 270px;
          height: 46px;
          background: linear-gradient(90deg, #ff6d42 0%, #ffa645 100%);
          box-shadow: 0px 5px 9px 0px rgba(251, 139, 76, 0.26);
          border-radius: 23px;
          border: 2px solid #ffffff;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #fff;
          line-height: 46px;
        }

        .right-image-title {
          width: 226px;
          margin: 36px auto 27px;
        }

        .case-container {
          overflow-x: scroll;

          .case-list {
            display: inline-flex;
            flex-wrap: nowrap;
            padding: 0px 20px;

            .case-item {
              width: 291px;
              height: 308px;
              margin-right: 10px;
            }

            .case-item:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .my-method-2-padding {
        padding: 20px 0px 23px;
      }
      .join-group {
        position: relative;
        background: linear-gradient(185deg, #fffcec 0%, #ffffff 100%);
        box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.03);
        border-radius: 16px;
        border: 1px solid rgba(255, 238, 195, 1);
        .join-group-btn {
          position: absolute;
          left: 50%;
          bottom: 32px;
          transform: translate(-50%, 0%);
          width: 305px;
          height: 46px;
        }
        img {
          width: 100%;
        }
      }
    }

    .content-item-4 {
      padding: 26px 20px 24px;

      .top-title {
        width: 241px;
        height: 22px;
        margin-bottom: 30px;
      }

      .i-title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #0d0d0d;
        line-height: 22px;
        margin-bottom: 6px;
      }

      .i-desc {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(13, 13, 13, 0.5);
        line-height: 19px;
        display: flex;
        align-items: flex-start;

        .iconfont {
          margin-right: 2px;
        }

        .danger {
          font-size: 14px;
          color: rgba(254, 160, 98, 1);
        }

        .zan {
          font-size: 12px;
          color: rgba(129, 239, 95, 1);
        }
      }

      .food-list {
        padding: 26px 0px 5px;
        margin-bottom: 26px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-bottom: 1px dashed rgba(13, 13, 13, 0.09);

        .food-pop-item {
          width: 25%;
          margin-bottom: 24px;
        }

        .food-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .item-image {
            width: 46px;
            height: 46px;
            position: relative;

            .wenhao {
              position: absolute;
              right: 0;
              top: 0;
              width: 12px;
              height: 12px;
              border-radius: 50%;
              background: #bfcccf;
              display: flex;
              align-items: center;
              justify-content: center;

              .iconfont {
                font-size: 16px;
                font-family: MiSans-Semibold, MiSans;
                font-weight: 600;
                color: #ffffff;
                transform: scale(0.5);
              }
            }

            .food-image {
              border-radius: 50%;
              overflow: hidden;
              object-fit: cover;
              width: 100%;
              height: 100%;
            }
          }

          .item-name {
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 2px;
            font-size: 11px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: rgba(13, 13, 13, 0.5);
            line-height: 16px;
          }
        }
      }

      .tips-text {
        max-width: 180px;
        padding: 8px 10px;
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 16px;
      }

      .recommend-food {
        margin-bottom: 20px;
        margin-top: 22px;
        padding-bottom: 22px;
        border-bottom: 1px dashed rgba(13, 13, 13, 0.09);

        .recommend-item {
          width: 100%;
          height: 94px;
          margin-bottom: 10px;
        }

        .recommend-item:last-child {
          margin-bottom: 0;
        }
      }

      .consult-us {
        .consult-top {
          display: flex;
          align-items: center;
          margin-bottom: 9px;

          .consult-avatar {
            width: 22px;
            height: 21px;
            object-fit: cover;
            margin-right: 7px;
          }

          .consult-nickname {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #0d0d0d;
            line-height: 20px;
          }

          .consult-btn {
            z-index: 1;
            position: relative;
            min-width: 67px;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 22px;
            background: linear-gradient(90deg, #ff6d42 0%, #ffa645 100%);
            box-shadow: 0px 2px 6px 0px rgba(255, 200, 107, 0.36);
            border-radius: 11px;
            font-size: 10px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fff;
            line-height: 22px;

            .consult-icon {
              display: flex;

              .iconfont {
                margin-left: 4px;
                width: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }

        .consult-text {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(13, 13, 13, 0.5);
          line-height: 18px;
        }
      }
    }

    .select-btn {
      margin: 0 auto 20px;
      width: 315px;
      text-align: center;
      height: 52px;
      background: #81ef5f;
      box-shadow: 0px 3px 9px 0px rgba(129, 239, 95, 0.5);
      border-radius: 26px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0d0d0d;
      line-height: 52px;
    }

    .launch-btn {
      position: relative;
      z-index: 1;
    }

    .fixed-btn {
      opacity: 0;
      position: fixed;
      z-index: 2;
      width: 100%;
      box-sizing: border-box;
      padding: 10px 30px 10px;
      background: #fbfeb2;
      left: 0;
      bottom: 0;
      transition: opacity 0.5s ease-in;
      @include paddingBottom(10px);

      .btn {
        height: 52px;
        background: linear-gradient(90deg, #ff6d42 0%, #ffa645 100%);
        box-shadow: 0px 5px 9px 0px rgba(251, 139, 76, 0.26);
        border-radius: 26px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        text-align: center;
        color: #fff;
        line-height: 52px;
      }
    }

    .fixed-btn-opacity-1 {
      opacity: 1;
    }

    .gray-logo {
      width: 58px;
      height: 10px;
      margin: 0 auto 100px;
    }
  }

  .download {
    position: sticky;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0.5px 0 #ededed;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    padding: 4px 15px;
    box-sizing: border-box;

    .logo {
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }

    .center {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      margin-right: 4px;

      .text1 {
        font-size: 15px;
        line-height: 23px;
      }

      .text2 {
        font-size: 10px;
        line-height: 16px;
        color: #999;
        word-break: break-all;
        white-space: pre-wrap;
      }
    }

    .btn {
      position: relative;
      width: 72px;
      background: linear-gradient(270deg, #6759ff 0%, #8b75ff 100%);
      height: 26px;
      text-align: center;
      border-radius: 13px;
      line-height: 26px;
      font-size: 13px;
      color: #fff;
    }
  }
}

@keyframes btnScale {
  0% {
    transform: translate(-50%, 0%) scale(1);
  }

  25% {
    transform: translate(-50%, 0%) scale(1.05);
  }

  50% {
    transform: translate(-50%, 0%) scale(1);
  }

  75% {
    transform: translate(-50%, 0%) scale(1.05);
  }

  100% {
    transform: translate(-50%, 0%) scale(1);
  }
}
</style>
